import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
//import "./Special/special.css";
import Button from 'react-bootstrap/Button';
import ThreeColumnTableCard from '../game-views/three_column_table_card';

class EditVariableEventsModal extends Component {
  constructor(props) {
    super(props);
    this.state={
      }    
    this.userAwardArr = [];
    this.preProcess();
}

preProcess(){
    this.variableEventCommentArr = [];
    let message = "";
    this.variableStringArr = [];
    // compare variable events to variable event responses --- ensure events are not missing a response
    // if match is found, confirm that tags within the var event responses exist and are valid
    for (let i=0; i<this.props.variableEvents.length; i++){
          const variableEvent = this.props.variableEvents[i];
          const varEventID = variableEvent.id;
          const variableResponses = this.props.variableEventResponses.filter(elem => elem.eventID === varEventID);
          if (variableResponses.length > 0){
              if (variableResponses.length > 1){
                  message = "More than 1 variable response for this event.";
              }else{
                    this.checkResponses(variableEvent.responses);
                    let variableStringObj = this.variableStringArr.find(elem => elem.fieldName === "itemDesc");
                    if (!variableStringObj){
                        message = "ItemDesc variable does not contain <<btnText>>";
                    }else{
                        if (variableStringObj.variableString === "<<btnText>>"){
                                //  this is correct
                        }else{
                            message = "ItemDesc variable string is not valid it is " + 
                                variableStringObj.variableString;
                            this.addToEventCommentArr(varEventID, variableEvent.title, message);
                        }
                    }
                    const variableStringArr = 
                        this.variableStringArr.filter(elem => elem.fieldName === "closureText");
                    if (variableStringArr.length === 0){
                        message = "ClosureText variable does not contain any text inserts.";
                        this.addToEventCommentArr(varEventID, variableEvent.title, message);
                    }else{
                        variableStringObj = variableStringArr.find(elem => elem.variableString === "<<addedText>>");
                        if (!variableStringObj){
                            message = "ClosureText variable does not contain <<addedText>>";
                            this.addToEventCommentArr(varEventID, variableEvent.title, message);
                        }
                        for (let j=0; j<variableStringArr.length; j++){
                            if (variableStringArr[j].variableString === "<<addedText>>" ||
                                variableStringArr[j].variableString === "<<insertText>>" ){
                                // all is well both of these are valid insert strings
                            }else{
                                message = "Insert string in closureText is not valid, string is: " +
                                    variableStringArr[j].variableString;
                                this.addToEventCommentArr(varEventID, variableEvent.title, message);
                            }   
                        }
                    }
              }
          }else{
              message = "No Variable Responses found for this event.";
          }
          if (message !== ""){
              this.addToEventCommentArr(varEventID, variableEvent.title, message);
          }
          this.variableStringArr = [];
    }
    if (this.variableEventCommentArr.length === 0){
          message = "No Issues Found With Variable Events";
          this.addToEventCommentArr("All Events", "", message);
    }
    
}

checkResponses(responses){
    for (let i=0; i<responses.length; i++){
          const response = responses[i];
          if (response.itemDesc){
              this.findVariableString(response.itemDesc, "itemDesc");
          }
          for (let j=0; j<response.possibleEffects.length; j++){
                const closureText = response.possibleEffects[j].closureText;
                this.findVariableString(closureText, "closureText");
          }
    }
}

findVariableString(inString, fieldName){
     let startChar = 0;
     while (startChar < inString.length){
          const currentChar = inString.charAt(startChar);
          if (currentChar === "<"){
              const endOfString = startChar + 2;
              const twoChars = inString.substring(startChar, endOfString);
              if (twoChars === "<<"){
                  const restOfString = inString.length;
                  const stringRemainder = inString.substring(startChar, restOfString);
                  const variableString = this.findEndOfString(stringRemainder);
                  if (variableString.length !== 0){
                      const stringObj = {variableString: variableString, fieldName: fieldName};
                      this.variableStringArr.push(stringObj);
                  }
              } 
          }
          startChar += 1;
     }
}

findEndOfString(inString){
    let variableString = "";
    let variableStringFound = false;
    let currentChar = 0;
    while (currentChar < inString.length && variableStringFound === false){
         let nextChar = "";
         nextChar = inString.charAt(currentChar);
         if (nextChar === ">"){
              const twoChars = inString.substring(currentChar, currentChar + 2);
              if (twoChars === ">>"){
                  const endChar = currentChar + 2;
                  variableString = inString.substring(0, endChar);
                  variableStringFound = true;
              }
         }
         currentChar += 1;
    }
    return variableString;
}

addToEventCommentArr(eventID, eventTitle, message){
    const rptObj = {label1: eventID, label2: eventTitle, label3: message};
    this.variableEventCommentArr.push(rptObj);
}


render() {
      const variableEventList = this.variableEventCommentArr.map((comments, index) =>
          <ThreeColumnTableCard outInfo={comments}  key={index}  
                infoType="label-label-label"
                />
          );
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="lg" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Variable Events Edit List </Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <span>
              <div className="ml-4 text-left">
                This displays a report of errors and informational items that are found
                in a review of the event-variable-responses mongoDB collection.
              </div>
              <table className="table table-hover">
                <tbody>
                  <tr>
                    <th>Event Id</th>
                    <th>Event Title</th>
                    <th>Comment/Error Text</th>
                  </tr>
                  {variableEventList}
                </tbody>
              </table>
                             
              </span>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
             
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
              
        </Modal.Footer>
       
    </Modal>
    
  </>
  }

}

export default EditVariableEventsModal;